<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="form">
        <b-form>
          <b-form-group>
            <b-form-input 
              id="documentoNumero"
              v-model.trim="$v.documentoNumero.$model" 
              :state="documentoNumeroValido"
              placeholder="Nro.DNI"
              @blur.native="resetValidations"
              type="text">
            </b-form-input>
            <b-form-invalid-feedback id="documentoNumeroFeedback">
              {{ documentoNumeroInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          <b-button class="link"
            @click.prevent="save">ENVIAR</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
  data () {
    return {
      evento: null,
      eventoNombre: '',
      documentoNumero: '',

      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
    }
  },
  created () {
    if (!this.$store.getters['user/loggedIn']) {
      this.$router.push({ name: 'Login' });
    }

    this.evento = this.$store.getters['eventos/evento'];
    if (this.evento) {
      this.eventoNombre = this.evento.nombre;
    }
    if (!this.evento) {
      this.$router.push({ name: 'SeleccionEvento' });
    }
  },
  methods: {
    resetValidations() {
      this.documentoNumeroValido = null;
      this.documentoNumeroInvalidoMsj = '';
    },
    save () {
      this.$v.$touch();

      if (this.$v.documentoNumero.$error) {
        if (!this.$v.documentoNumero.required) {
          this.documentoNumeroValido = false;
          this.documentoNumeroInvalidoMsj = 'Debe ingresar el DNI';
          return;
        }      
        if (!this.$v.documentoNumero.numeric) {
          this.documentoNumeroValido = false;
          this.documentoNumeroInvalidoMsj = 'El DNI debe ser un valor numérico';
          return;
        }      
      } else {
        this.documentoNumeroValido = null;
        this.documentoNumeroInvalidoMsj = '';
      }

      /*
      var participante = {
        documentoNumero: this.documentoNumero,
      }
      */
      this.$store.dispatch('participante/setDocumentoParticipante', this.documentoNumero)
        .then(response => {
          this.$router.push({ name: 'IngresoCelular' });
        })
        .catch( error => {
          console.log(error.errorMessage);
        });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  },
  validations: {
    documentoNumero: {
      required,
      numeric
    },
  },  
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoManualDocumento.vue